import React from 'react';
import { PageCard as StyledPageCard } from './styles';

interface PageCardProps {
  children: React.ReactNode;
  padding?: number;
  backgroundRequired?: boolean;
}

const PageCard: React.FC<PageCardProps> = ({ children, padding = 5, backgroundRequired = true }) => {
  return (
    <StyledPageCard padding={padding} backgroundRequired={backgroundRequired}>
      {children}
    </StyledPageCard>
  );
};

export default PageCard;